module.exports = __webpack_public_path__ + "img/Path 14 Copy 2@3x.364b87cc.png";